import React, { useState } from "react";
import styled from "styled-components";

import Language from "@material-ui/icons/Language";
import Person from "@material-ui/icons/Person";
import ExitToApp from "@material-ui/icons/ExitToApp";

import { InertiaLink, usePage } from "@inertiajs/inertia-react";
import { Box, Container, Popover } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import { Inertia } from "@inertiajs/inertia";
import Alert from "@material-ui/lab/Alert";
import { Trans } from "../../utils/i18n";
import { useLanguageSwitch } from "../../hooks/useLanguageSwitch";
import FlashMessage from "../FlashMessage";
import ClientSwitcher from "../ClientSwitcher";

const Nav = styled.nav`
    width: 100%;
    background-color: ${(props) => props.color || props.theme.primary};
    padding: 15px;
    font-size: 30px;
`;

const Left = styled.div`
    flex: 1;
    display: flex;
    flex-direction: row;
    padding: 10px;
    flex-wrap: wrap;
`;

const Heading = styled.h1`
    color: ${(props) => props.theme.white};
    display: block;
    margin: 0;
    margin-top: 10px;
    font-size: 20px;

    @media (min-width: 800px) {
        font-size: 45px;
    }
`;

const Right = styled.div`
    display: flex;
    align-items: center;
`;

const Logo = styled.img`
    width: auto;
    height: 70px;
    margin-right: 10px;
`;

const StyledLanguage = styled(Language)`
    cursor: pointer;
`;

const PopoverContent = styled.div`
    padding: 0 20px;
    border-radius: 10px;
`;

const LanguageSelect = styled.p`
    cursor: pointer;
    color: ${(props) => props.theme.primary};
`;

const Footer = styled.footer`
    background-color: #fff;
    color: ${(props) => props.theme.secondary};
    font-size: 14px;
    padding: 30px;
`;

export default function UnzerLayout({ children, wrapperStyle }) {
    const {
        props: { flash, user, languages },
    } = usePage();
    const { updateLanguage } = useLanguageSwitch();

    const handleLogoutClick = async () => {
        Inertia.post(route("logout"));
    };

    const [langSwitchElement, setLangSwitchElement] = useState();

    const handleLangClick = (event) => {
        setLangSwitchElement(event.currentTarget);
    };

    const handlePopoverClose = () => {
        setLangSwitchElement(null);
    };

    const handleLanguageChange = (language) => {
        setLangSwitchElement(null);
        updateLanguage(language);
    };

    const open = Boolean(langSwitchElement);

    return (
        <>
            <Nav color={"" || children.props.client.brand_color_header}>
                <Container maxWidth="lg">
                    <Grid container spacing={3}>
                        <Left>
                            {children.props.client.brand_logo && (
                                <Logo
                                    src={children.props.client.brand_logo}
                                />
                            )}
                            <Heading
                                style={{
                                    color: children.props.client
                                        .brand_color_header_icons,
                                }}
                            >
                                <Trans i18nKey="layout.oneConnect">
                                    ONE CONNECT
                                </Trans>
                            </Heading>
                        </Left>
                        <Right>
                            <StyledLanguage
                                style={{
                                    color: children.props.client
                                        .brand_color_header_icons,
                                }}
                                onClick={handleLangClick}
                            />
                            <Popover
                                id={open ? "language-popover" : undefined}
                                open={open}
                                anchorEl={langSwitchElement}
                                onClose={handlePopoverClose}
                                anchorOrigin={{
                                    vertical: "bottom",
                                    horizontal: "center",
                                }}
                                transformOrigin={{
                                    vertical: "top",
                                    horizontal: "center",
                                }}
                            >
                                <PopoverContent>
                                    {languages.map((item) => (
                                        <LanguageSelect
                                            onClick={() =>
                                                handleLanguageChange(item.code)
                                            }
                                            key={item.code}
                                        >
                                            { item.name }
                                        </LanguageSelect>
                                    ))}
                                </PopoverContent>
                            </Popover>
                            <ClientSwitcher />
                            {children.props.user?.id && (
                                <InertiaLink
                                    href={route("profile")}
                                    style={{ lineHeight: 0 }}
                                >
                                    <Person
                                        style={{
                                            color: children.props.client
                                                .brand_color_header_icons,
                                        }}
                                    />
                                </InertiaLink>
                            )}
                            {children.props.user?.id && (
                                <ExitToApp
                                    onClick={handleLogoutClick}
                                    style={{
                                        color: children.props.client
                                            .brand_color_header_icons,
                                        cursor: "pointer",
                                    }}
                                />
                            )}
                        </Right>
                    </Grid>
                </Container>
            </Nav>
            <Box paddingY={8} style={wrapperStyle}>
                {children}
            </Box>
            <Footer>
                <Grid container maxWidth="md" spacing={3} justifyContent="center">
                    <Grid item xs={12}>
                        <ul className={'flex flex-col items-center list-none'}>
                            <li className={'mt-2'}>
                                <a className={'no-underline text-[#1b6ad6] hover:text-[#fc0f54] text-center'} href="https://www.unzer.com/de/impressum/" target="_blank">Impressum</a>
                            </li>
                            <li className={'mt-2'}>
                                <a className={'no-underline text-[#1b6ad6] hover:text-[#fc0f54] text-center'} href="https://www.unzer.com/de/datenschutz/#footer-section"><Trans i18nKey={'privacypolicy'}>Our Privacy Policy</Trans></a>
                            </li>
                        </ul>
                    </Grid>
                </Grid>
            </Footer>
            {flash.status && (
                <FlashMessage message={flash.status} />
            )}
            {flash.message && (
                <FlashMessage message={flash.message} />
            )}
            {flash.warning && (
                <FlashMessage message={flash.warning} type={'warning'} />
            )}
        </>
    );
}
